import React, { createContext, useContext, useMemo } from 'react';
import type { ReactNode } from 'react';
import { useApp } from '../hooks/use-app';
import type { Config } from '../models/config';

export interface AppConfig {
  esriApiKey: string;
}

export function mapConfig(raw: Config): AppConfig {
  return {
    esriApiKey: raw.esri_api_key,
  };
}

export const ConfigContext = createContext<AppConfig | null>(null);

interface ConfigProviderProps {
  children: ReactNode;
}

export const ConfigProvider: React.FC<ConfigProviderProps> = ({ children }) => {
  const app = useApp();
  const rawConfig = app.globals.config;

  const config = useMemo<AppConfig>(() => mapConfig(rawConfig), [rawConfig]);

  return (
    <ConfigContext.Provider value={config}>
      {children}
    </ConfigContext.Provider>
  );
};

export function useConfig(): AppConfig {
  const config = useContext(ConfigContext);
  if (!config) {
    throw new Error('useConfig must be used within a ConfigProvider');
  }
  return config;
}
